/**
 * Design Tokens: Typography
 * Centralized typography definitions
 */

export const typography = {
  fontFamily: {
    primary: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
    mono: '"Fira Code", "Consolas", "Monaco", monospace',
  },

  fontSize: {
    xs: 10,
    sm: 11,
    md: 12,
    base: 13,
    lg: 14,
    xl: 16,
    '2xl': 18,
    '3xl': 20,
    '4xl': 24,
  },

  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },

  lineHeight: {
    tight: 1.2,
    normal: 1.5,
    relaxed: 1.75,
  },

  // Pre-defined text styles
  variants: {
    tableHeader: {
      fontSize: 11,
      fontWeight: 600,
    },
    tableCell: {
      fontSize: 11,
      fontWeight: 600,
    },
    tableCellValue: {
      fontSize: 12,
      fontWeight: 600,
    },
    label: {
      fontSize: 12,
      fontWeight: 500,
    },
    caption: {
      fontSize: 10,
      fontWeight: 400,
    },
  },
} as const;

export type Typography = typeof typography;
